// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1850": "56b71224","4636": "bb3c224b","506": "642923c5","6315": "0b879821","9066": "c1fdd670",}[chunkId] + ".css"
}